import { Colors, Icon } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface PerformanceHeroProps {
    dataTestId?: string;
}

export const PerformanceHero = ({ dataTestId = 'performance-hero' }: PerformanceHeroProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div
            className={
                'flex w-full max-w-[515px] flex-col items-start gap-3 rounded-2xl border border-white bg-white/45 p-4 backdrop-blur-[2px] md:!p-8'
            }
            data-testid={dataTestId}
        >
            <div className={'flex w-full items-start gap-4'}>
                <div
                    className={
                        'flex h-20 w-20 shrink-0 items-center justify-center rounded-full bg-teal-50/70'
                    }
                >
                    <Icon
                        name={'arrow-refresh-2'}
                        size={36}
                        color={Colors.PRIMARY}
                    />
                </div>

                <div className={'flex min-w-0 flex-1 flex-col gap-2 md:gap-3.5'}>
                    <h3 className={'text-[24px] font-medium text-gray-900'}>
                        {t('managerAssessmentEvaluation.prepareAssessment')}
                    </h3>

                    <p className={'text-[12px] leading-normal text-gray-900'}>
                        {t('managerAssessmentEvaluation.prepareAssessmentDesc')}
                    </p>
                </div>
            </div>
        </div>
    );
};
